import { render, staticRenderFns } from "./AddPaperManagement.vue?vue&type=template&id=0fb206f6&scoped=true&"
import script from "./AddPaperManagement.vue?vue&type=script&lang=js&"
export * from "./AddPaperManagement.vue?vue&type=script&lang=js&"
import style0 from "./AddPaperManagement.vue?vue&type=style&index=0&id=0fb206f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb206f6",
  null
  
)

export default component.exports